import React, {useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import useClusterService from "../../../../../services/ClusterService";
import {BreadcrumbContext, HeadlineContext, SidebarContext} from "../../../../LoggedInApp";
import useBreadcrumbs from "../../../../ui/useBreadcrumbs";
import BackToClustersLink from "../../../../ui/BackToClustersLink";
import ClusterDetailsSidebar from "../../ClusterDetailsSidebar";
import ClusterHeadline from "../../../../ui/ClusterHeadline";
import useClusterDataService from "../../../../../services/ClusterDataService";
import {DateTime} from "luxon";
import PrimaryHelp from "../../../../ui/PrimaryHelp";
import DataStatus from "../DataStatus";
import numeral from "numeral";
import LoadingDialog from "../../../../misc/LoadingDialog";

export default function UavPage() {

  const { uuid } = useParams();

  const clusterService = useClusterService();
  const clusterDataService = useClusterDataService();

  const headline = useContext(HeadlineContext);
  const sidebar = useContext(SidebarContext);

  const [cluster, setCluster] = useState(null);
  const [summary, setSummary] = useState(null);

  const [revision, setRevision] = useState(DateTime.now());

  useBreadcrumbs(useContext(BreadcrumbContext), <BackToClustersLink />)

  useEffect(() => {
    sidebar.set(<ClusterDetailsSidebar cluster={null} clusterId={uuid} />);
    setCluster(null);
    clusterService.findOneCluster(uuid, setCluster);
    return () => {
      sidebar.set(null);
    };
  }, [uuid]);

  useEffect(() => {
    if (cluster !== null) {
      headline.set(<ClusterHeadline cluster={cluster} />)
      sidebar.set(<ClusterDetailsSidebar cluster={cluster} clusterId={uuid} />);

      setSummary(null);
      clusterDataService.getUavSummary(cluster.uuid, setSummary);
    }

    return () => {
      headline.set(null);
      sidebar.set(null);
      setSummary(null);
    };
  }, [cluster, revision]);

  const onChange = () => {
    setRevision(DateTime.now());
  }

  if (!cluster || !summary) {
    return <LoadingDialog />
  }


  return (
    <React.Fragment>
      <div className="row">
        <div className="col col-12">
          <div className="section">
            <h2>UAV Information</h2>

            <PrimaryHelp>
              Make, model, classification and other details of unmanned aerial vehicles (UAVs), looked up by serial
              number. Whenever Nzyme identifies the serial number of a detected UAV, it uses this data to enrich the
              detection.
            </PrimaryHelp>

            <DataStatus dataType="uav" cluster={cluster} status={summary.is_enabled} onChange={onChange} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col col-12">
          <div className="section">
            <h3>Provided Data</h3>

            <table className="table table-hover">
              <thead>
              <tr>
                <th>Data Type</th>
                <th>Record Count</th>
                <th>Description</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>UAV Models</td>
                <td>{numeral(summary.models.size).format("0,0")}</td>
                <td>Model and Classification Information of UAVs (Unmanned Aerial Vehicles)</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  )

}